import { render, staticRenderFns } from "./OficialDocuments.vue?vue&type=template&id=04534076&"
import script from "./OficialDocuments.vue?vue&type=script&lang=js&"
export * from "./OficialDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports